<template>
  <div class="card dash-card headercard" style="margin-top:2px; height:500px;">
    <div class="card-header dash-card-header row flex-shrink-0">
      <div class="col-5 header-line" ></div>
      <div class="col-2 header-line">
        <lambo-header-item  :dashdata="dashdata"
                            :kpi="getKpiByString('07. Sales Process')"
                            class="col-12" />
      </div>
      <div class="col-5 header-line"></div>
    </div>

    <div class="card-body p-0 m-0">
      <div class="il-table">
        <div class="i-row">

          <div class="i-cell col-2">
            <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('5. Welcome')" :isHeader="true" />
            <titleunderline />
            <div class="dash-card-inner">
              <div class="row no-gutters">
                <div class="col-12">
                  <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('05.1 You were welcomed by a Salesperson or another employee of the dealership within 5 minutes?')" />
                </div>
              </div>
            </div>
          </div>
         
          <div class="i-cell col-2">
            <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('6. Establishing customer requirements')" :isHeader="true" />
            <titleunderline />
            <div class="dash-card-inner">
              <div class="row no-gutters">
                <div class="col-12">
                  <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('06.1-6.1.9 Customer needs')" />
                </div>
              </div>
            </div>
          </div>
          
          <div class="i-cell col-2">
            <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('7. Pre-owned vehicle presentation')" :isHeader="true" />
            <titleunderline />
            <div class="dash-card-inner">
              <div class="row no-gutters">
                <div class="col-12">
                  <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('07.6.4-7.6.5 Brand and Car presentation')" />
                </div>
              </div>
            </div>
          </div>

          <div class="i-cell col-2">
            <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('8. Test Drive')" :isHeader="true" />
            <titleunderline />
            <div class="dash-card-inner">
              <div class="row no-gutters">
                <div class="col-12">
                  <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('08.1 Did the Salesperson actively offer a test drive?')" />
                </div>
              </div>
            </div>
          </div>

          <div class="i-cell col-2">
            <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('9. Offer/Negotiation')" :isHeader="true" />
            <titleunderline />
            <div class="dash-card-inner">
              <div class="row no-gutters">
                <div class="col-12">
                  <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('09.1.2 … for your complete personal data …')" />
                  <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('09.2 The Salesperson asked if you have a used vehicle to trade in?')" />
                  <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('09.4 Did the Salesperson actively propose a written offer?')" />
                  <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('09.5.1 … communicated spontaneously the expected delivery timing?')" />
                </div>
              </div>
            </div>
          </div>

          <div class="i-cell col-2">
            <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('10. Follow up')" :isHeader="true" />
            <titleunderline />
            <div class="dash-card-inner">
              <div class="row no-gutters">
                <div class="col-12">
                  <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('10.1 The Salesperson reached you on the phone or by email/text message within 7 working days?')" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import performanceitem from './PerformanceItem'
  import tableitem from './TableItem.vue'
  import titleunderline from './TitleUnderline'
  import KpiMixin from '@/mixins/lambo/KpiMixin';
  import LamboHeaderItem from './LamboHeaderItem';

  export default {
    components: {
      performanceitem,
      tableitem,
      titleunderline,
      LamboHeaderItem
    },

    mixins: [ KpiMixin ]
  }
</script>

<style lang="scss" scoped>
  @import "@/../scss/lambo/variables.scss";

  .dash-card >>> .kpitable {
    max-width: 208px;
  }
  
  .dash-card-header {
    height: 90px !important;
  }

  .header-line {
    height: 100%;
    border: 0px;
    background-color: $lambo-header-color-alt;
  }
</style>
